export default function R_Exercises() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Exercises Component</h1>
      <p>This is the R_Exercises tutorial section.</p>
    </div>
  );
}
